<template>
  <v-form v-model="valid" ref="form">
    <v-row>
      <v-col cols="12">
        <date-iso-picker :date.sync="dob" dense outlined></date-iso-picker>
      </v-col>
      <v-col cols="12">
        <v-text-field dense outlined v-model="currentLive" label="Nơi ở hiện tại"></v-text-field>
        <v-textarea
          v-model="classes"
          auto-grow
          outlined
          dense
          disabled
          label="Các lớp giảng dạy"
        ></v-textarea>
        <autocomplete-major
          v-model="majors"
          item-text="title"
          item-value="id"
          outlined
          dense
          label="Chuyên Ngành"
          required
          multiple
        ></autocomplete-major>
        <v-text-field
          type="number"
          min="0"
          step="10"
          label="Giảng phí (VND)"
          outlined
          dense
          v-model="rate"
          v-if="canEditRate"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import DateIsoPicker from '@/components/basic/picker/DateIOSPicker'
import AutocompleteMajor from '@/components/basic/input/AutocompleteMajor.vue'
import { get } from 'lodash'
import { mapState } from 'vuex'

export default {
  components: {
    DateIsoPicker,
    AutocompleteMajor
  },
  props: {
    teacher: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  computed: {
    ...mapState('auth', ['profile', 'role']),
    canEditRate() {
      return ['super_admin'].includes(this.role.type)
    }
  },
  data: () => ({
    valid: true,
    dob: new Date().toISOString(),
    currentLive: '',
    classes: '',
    majors: '',
    rate: ''
  }),
  created() {
    this.reset()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      this.currentLive = get(this.teacher, 'metadata.currentLive', '')
      this.rate = get(this.teacher, 'metadata.rate', '')
      this.dob = get(this.teacher, 'metadata.dob', `${new Date().toISOString()}`)
      this.classes = (this.teacher.classes || []).map(x => ` ${x.title}`)
      this.majors = (this.teacher.majors || []).filter(m => !!m)
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      return {
        currentLive: this.currentLive,
        dob: this.dob,
        majors: this.majors,
        rate: this.rate
      }
    }
  },
  watch: {
    teacher(teacher) {
      this.reset()
    }
  }
}
</script>

<style>
input {
  margin: 8px 0px;
}
</style>
